import {
  Paper,
  Container,
  Button,
  TextField,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { styles } from "../helpers";
import QuizAnswers from "./QuizAnswers";
import LanguageSelector from './LanguageSelector';
import { useState, useEffect } from "react";
import libroPortada from '../images/libro.png';
import poweredBy from '../images/pasiona.png';
import stringsEs from '../common/string_es_ES.json';
import stringsEn from '../common/string_en_UK.json';
import quizDataEs from '../questions/q_es_ES.json';
import quizDataEn from '../questions/q_en_UK.json';
import answerDataEs from '../questions/a_es_ES.json';
import answerDataEn from '../questions/a_en_UK.json';
const configCode = process.env.REACT_APP_VERIFICATION_CODE;

const useStyles = makeStyles((theme) => {
  return styles;
});

const QuizCategories = () => {
  const classes = useStyles();
  const [currentQuizStep, setCurrentQuizStep] = useState("start");
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorEmail, setErrorEmail] = useState("");
  const [answerSecurity, setAnswerSecurity] = useState("");
  const [isCorrectAnswerSecurity, setIsCorrectAnswerSecurity] = useState(false);
  const [isButtonSubmitModalDisabled, setIsButtonSubmitModalDisabled] = useState(true);
  const [language, setLanguage] = useState("es_ES");
  const [quiz, setQuiz] = useState(quizDataEs);
  const [quizResults, setQuizResults] = useState(answerDataEs);
  const [translationString, setTranslationString] = useState(stringsEs);
  useEffect(() => mailQS());

  useEffect(() => canBeSubmitted());

  //preguntas
  const quizLang = {
    "es_ES": quizDataEs,
    "en_UK": quizDataEn
  }

  //respuestas
  const answerLang = {
    "es_ES": answerDataEs,
    "en_UK": answerDataEn
  }

  //texto en general
  const stringsLang = {
    "es_ES": stringsEs,
    "en_UK": stringsEn
  }

  useEffect(() => {
    setQuiz(quizLang[language]);
    setQuizResults(answerLang[language])
    setTranslationString(stringsLang[language])
  }, [language])  

  const forceClose = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  const handleClose = (e) => {
    // debugger;
    e.preventDefault();
    setOpen(false);
    setErrorEmail("");
    setCurrentQuizStep("quiz");
    // else{
    //   setErrorEmail("Introduzca un dirección de correo válida.")
    // }
  }; 

  const handleChange = event => {
    const val = event.target.value;
    const field = event.target.id;
    debugger;
    if(field === "verification-code"){
      setAnswerSecurity(val);
      val === configCode ? setIsCorrectAnswerSecurity(true) : setIsCorrectAnswerSecurity(false);
    }
    else{
      if(isEmail(event)) {
        setIsValidEmail(true);
                  
      } else {
        setIsValidEmail(false);              
      }
           
      setEmail(val);    
    }
            
 }

 const mailQS = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const email = queryParams.get("email");

  if(email){
    setCurrentQuizStep("quiz");
  }
 }

  const canBeSubmitted = () => {
    if(isValidEmail && isCorrectAnswerSecurity){
      return setIsButtonSubmitModalDisabled(false);
    }
    else{
      setIsButtonSubmitModalDisabled(true)
    }
  };

  const handleResult = (e) => {
    e.preventDefault();
    setOpen(true);
    // setCurrentQuizStep("quiz");
  };

  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  const isEmail = (e) => {
    return e.target?.value && e.target.value.match(emailRegex)    
  }

  const Emoji = props => (
    <span
      className="emoji"
      role="img"
      aria-label={props.label ? props.label : ""}
      aria-hidden={props.label ? "false" : "true"}
    >
      {props.symbol}
    </span>
  );
  

  return (
    <Container className={classes.container}>
      {currentQuizStep === "start" ? (
      <>
        <Typography variant="h1" className={classes.subTitleHome}>
          <span>{translationString.welcome_title} </span>
        </Typography>
        <Paper className={classes.paper}>               
          <div className={classes.topic_wrapper}>
            <form onSubmit={handleResult}>
              <div className={classes.category_wrapper}>
                <LanguageSelector setLanguage={setLanguage}/>
                <p>{translationString.introduction_text_1}</p>
                <p>{translationString.introduction_text_2}</p>
                <div className={classes.homeSubcontainer}>
                  <div>
                    <p>{translationString.category_label}</p>
                    <ul className={classes.listTopics}>
                      {translationString.categories.map(c => {
                        return (                      
                          <li className="listTopicsItem">{c}</li>
                        )
                      })}
                    </ul>
                    <p>{translationString.enjoy_process}</p>
                  </div>
                  <div>
                    <img className={classes.imagePortada} src={libroPortada} alt='Portada'/>
                  </div>
                </div>
                <div className={classes.buttonContainer}>
                  <div>
                    <a href="https://pasiona.com" target="_blank" rel="noreferrer">
                      <img className={classes.imagePoweredby} src={poweredBy} alt='Powered by pasiona consulting'/>
                    </a>
                  </div>
                  <div>
                    <Button
                        className={classes.submitButton}
                        variant="contained"
                        color="primary"
                        type="submit"
                    >
                        {translationString.start_button_text}
                    </Button>
                  </div>                  
                </div>              
                </div>
            </form>
          </div>
        </Paper>
        <Dialog onClose={forceClose} aria-labelledby="customized-dialog-title" open={open}>
            <DialogTitle id="customized-dialog-title" onClose={forceClose}>
              {translationString.access_form_title}
            </DialogTitle>
            <DialogContent dividers>
              <FormControl fullWidth variant="outlined">
                <p className={classes.question} >{translationString.verification_code_title}</p>
                <TextField 
                  required
                  id="verification-code" 
                  label={translationString.verification_code_label} 
                  variant="outlined"
                  type="number"
                  value={answerSecurity}
                  onChange={e => handleChange(e)}
                  />
                </FormControl>                
              <FormControl fullWidth variant="outlined">
                <p className={classes.question} >{translationString.email_title}</p>
                <TextField 
                  required
                  id="email" 
                  label={translationString.email_label}
                  variant="outlined" 
                  value={email}
                  onChange={e => handleChange(e)}
                  />
                  <p className={classes.emailError}>{errorEmail}</p>
                </FormControl>
                {/* <FormGroup>
                  <FormControlLabel control={<Checkbox onChange={handleChangeAccept}/>} label={
                     <p>He leído y acepto la <a href={libroPortada} target="_blank" rel="noreferrer">Política de privacidad</a></p>
                  } />
                </FormGroup>                     */}
            </DialogContent>
            <DialogActions>
              <Button 
                autoFocus
                disabled={isButtonSubmitModalDisabled}
                onClick={handleClose}
                classes={{ disabled: classes.submitButtonDisabled}}
                className={classes.submitButton}
                >
                {translationString.access_button_text}
              </Button>
            </DialogActions>
          </Dialog>    
      </>      
      ): (
          <QuizAnswers
            classes={classes}
            quizData={quiz}
            email={email}
            quizResults={quizResults}
            translationString={translationString}
          />
      )}
    </Container>
  );
};

export default QuizCategories;
